import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { getValueLabelPairsFromTree } from './helpers';

const DEFAULT_VALUE = 3;

const StyPaper = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.primary.background,
    padding: theme.spacing(1),
    textAlign: 'center',
}));

const ShowAllowedAccesses = ({
    filterScope,
    tree,
}: {
    filterScope: string[];
    tree: TreeT;
}): JSX.Element => {
    const { t } = useTranslation();
    const [isShowingAllAccesses, setIsShowingAllAccesses] = useState(false);

    const treeValueLabelPairs = getValueLabelPairsFromTree(tree, true);
    const translatedAccessesFromTree = filterScope.map(
        (scope) => treeValueLabelPairs[scope] ?? scope,
    );

    const renderAccesses = (accesses: string[]) => {
        const accessesToRender = isShowingAllAccesses
            ? accesses
            : accesses.slice(0, DEFAULT_VALUE);
        return accessesToRender.map((access) => (
            <Grid key={`${access}-access`} item xs={12} sm={4}>
                <StyPaper>{access}</StyPaper>
            </Grid>
        ));
    };

    return (
        <>
            <Grid
                alignItems="center"
                container
                spacing={1}
                sx={{
                    overflow: 'auto',
                    marginTop: '0.5rem',
                    maxHeight: '150px',
                }}
            >
                {renderAccesses(translatedAccessesFromTree)}
            </Grid>
            {translatedAccessesFromTree.length > DEFAULT_VALUE && (
                <div style={{ marginTop: '0.3rem', textAlign: 'right' }}>
                    <Button
                        onClick={() =>
                            setIsShowingAllAccesses(!isShowingAllAccesses)
                        }
                    >
                        {isShowingAllAccesses
                            ? t('treeTableModal.showAllowedAccesses.showLess')
                            : `${t(
                                  'treeTableModal.showAllowedAccesses.showMore',
                              )} (${translatedAccessesFromTree.length})`}
                    </Button>
                </div>
            )}
        </>
    );
};

export default ShowAllowedAccesses;
